var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"fill":"#373C43","fill-rule":"nonzero"}},[_c('g',[_c('path',{attrs:{"d":"M10 1.708L8.182 0 0 7.684 0.009 7.692 0 7.701 8.182 15.385 10 13.677 3.627 7.692z"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }